import React from 'react';
import type { SortDirection } from '../../types/table';

/**
 * SortIcon Component - Atomic Level
 * 
 * Visual indicator for column sorting state
 * Shows up/down arrows based on sort direction
 * 
 * Features:
 * - Three states: unsorted, ascending, descending
 * - Smooth transitions
 * - Accessible (ARIA labels)
 */

export interface SortIconProps {
  /** Current sort direction */
  direction: SortDirection;
  /** Additional CSS classes */
  className?: string;
}

export const SortIcon: React.FC<SortIconProps> = ({ direction, className = '' }) => {
  return (
    <div className={`inline-flex flex-col ml-1 ${className}`} aria-label={`Sort ${direction || 'unsorted'}`}>
      {/* Up Arrow */}
      <svg
        className={`w-3 h-3 transition-colors ${
          direction === 'asc' ? 'text-[#EAB308]' : 'text-gray-300'
        }`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
          clipRule="evenodd"
        />
      </svg>
      {/* Down Arrow */}
      <svg
        className={`w-3 h-3 -mt-1 transition-colors ${
          direction === 'desc' ? 'text-[#EAB308]' : 'text-gray-300'
        }`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
};

export default SortIcon;

